import { render, staticRenderFns } from "./ParentView.vue?vue&type=template&id=22772df0&"
import script from "./ParentView.vue?vue&type=script&lang=js&"
export * from "./ParentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports